export default `
.root-menu {
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

a {
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  position: relative;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #43414C;
}

li {
  list-style: none;
  position: relative;
}

.min-size {
  width: 40px !important;
  overflow: hidden;
}
.min-size label {
  font-size: 12px !important;
}
.min-size .active {
  color: #ffffff !important;
  border: none;
  background: #6d2ef8 !important;
  border-radius: 4px;
}
.min-size > li {
  margin: 2px 0;
}
.min-size > li > a {
  height: 36px;
  line-height: 36px;
  margin-left: 4px;
  padding-left: 10px;
}
.min-size > li > a:hover {
  border-radius: 4px;
  background-color: #6d2ef8;
}
.min-size > li i.layout {
  margin-right: 16px;
}
.min-size > li > a:hover i.layout[class$="gray"] {
  display: none;
}
.min-size > li > a:hover i.layout[class$="light"] {
  color: #ffffff;
  display: inline-block !important;
}
.min-size > li > a.active i.layout[class$="light"] {
  color: #ffffff;
  display: inline-block !important;
}
.min-size > li > a:hover ~ ul, .min-size .level2:hover {
  display: block !important;
  position: fixed;
  left: 36px;
  z-index: 1800;
  width: 140px;
  transform: translateY(-80px);
  box-shadow: 1px 1px 5px #bab7b7;
}
.min-size .level2 a {
  height: 26px;
  line-height: 26px;
  padding-left: 16px;
}
.min-size .level3 a {
  padding-left: 28px;
}
.min-size .tri-down:after {
  top: 8px;
}
.min-size .level2input:checked + .tri-down:after {
  top: 12px;
}
.min-size .level1input + .tri-down:after {
  right: -10px !important;
}
.min-size input:checked ~ .level2 {
  display: none !important;
}

input:checked ~ ul {
  display: block !important;
}

label {
  display: block;
  width: 100%;
  color: inherit;
  user-select: none;
  cursor: pointer;
}

ul, li {
  padding: 0;
  margin: 0;
}

i.layout {
  // width: 14px;
  // height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #1D1C23;
  margin-right: 10px;
}

.level1 {
  width: 160px;
  background: #f8f8fa;
}
.level1 a {
  font-weight: 600;
  font-size: 14px;
  padding-left: 16px;
}
.level1 a:hover {
  color: #6d2ef8;
  background: rgba(135, 87, 249, 0.06);
}
.level1 a:hover i.layout {
  color: #6d2ef8;
}
.level2 {
  background: #f8f8fa;
}
.level2 a {
  padding-left: 40px;
  height: 36px;
  font-size: 13px;
  font-weight: 400;
  line-height: 36px;
}
.level2 label {
  display: flex;
  font-size: 13px;
  align-items: center;
}
.level3 a {
  font-size: 12px;
  font-weight: 400;
  padding-left: 54px;
}

.menu {
  line-height: normal !important;
}
.active {
  color: #6d2ef8 !important;
  font-weight: 600;
  border-right-style: solid;
  border-right-width: 4px;
  border-color: #6d2ef8;
  background: linear-gradient(270deg, #DED4FE 0%, #E8E1FF 100%) !important;
}
.active i.layout[class$="gray"] {
  display: none;
}
.active i.layout[class$="light"] {
  color: #6d2ef8;
  display: inline-block !important;
}
.activelink {
  color: #1D1C23;
  font-weight: 700;
}
.level1_dark .activelink {
  color: #ffffff !important;
}
.level1_dark .activelink img {
  filter: brightness(0) invert(1);
}
.level1input:checked + .tri-down:after {
  top: 20px;
  transform: rotate(-135deg);
}
.level2input:checked + .tri-down:after {
  top: 17px;
  transform: rotate(-135deg);
}
.level2input:checked + .tri-down label {
  font-weight: 600;
}

.mark:before {
  content: '';
  width: 6px;
  height: 6px;
  background: #FF2910;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  margin-top: -3px;
  left: 8px;
}
.min-size > li .mark:before {
  top: 50%;
  margin-top: -10px;
  right: 8px;
  left: unset;
}
.min-size .level2 .mark:after {
  top: 12px;
}

.tri-down:after {
  content: '';
  width: 0;
  height: 0;
  padding: 3px;
  border-right: 1.5px solid #b3b1b1;
  border-bottom: 1.5px solid #b3b1b1;
  position: absolute;
  top: 12px;
  right: 15px;
  transform: rotate(45deg);
  transition: transform 0.2s;
}
.level1 > li > .tri-down:after {
  top: 15px;
}

.level1_dark {
  background: #150448;
}
.level1_dark a {
  color: #deded0;
}
.level1_dark .active {
  color: #ffffff !important;
  font-weight: 600;
  border-right-style: solid;
  border-right-width: 4px;
  border-color: #8757F9;
  background: linear-gradient(270deg, #5C2ED4 0%, #3C0D8D 100%) !important;
}
.level1_dark .active i.layout[class$="gray"] {
  display: none;
}
.level1_dark .active i.layout[class$="light"] {
  color: #ffffff !important;
  display: inline-block !important;;
}
.level1_dark .level2 {
  background: #150448;
}
.level1_dark .level2 a {
  color: #ffffff;
}
.level1_dark .level3 {
  background: #150448;
}
.level1_dark a:hover {
  color: #ffffff;
  background: rgba(109, 46, 248, 0.2);
}
.level1_dark i.layout[class$="gray"] {
  color: #ffffff !important;
}
`



// WEBPACK FOOTER //
// ./src/layout/layout/menu-style.js